<div class="section-gap" *ngIf="imagePosition !='image-as-background'">
  <div class="container">
    <div class="blog-alternate mb-5">
      <div class="row flex-lg-row flex-column">
        <div class="col-12 col-lg-auto" *ngIf="imagePosition=='left'" [ngStyle]="{'max-width': displayWidth < 992 ? '100%' : '50%'}">
          <div class="overlay-wrap" [ngStyle]="{'max-width': imageWidth, 'max-height': imageHeight }">
            <kla-image-object [imageWidth]="imageWidth" [imageHeight]="imageHeight" [imageObject]="imageObject"></kla-image-object>
          </div>
        </div>

        <div [class]="imagePosition=='full-width' ? 'col-12': 'col-lg-6 col-12'">
          <app-badges [badges]="titleConfigurations.badges"></app-badges>
          <div>
            <div class="d-flex align-items-center">
              <h3 [id]="titleConfigurations.title | stripSpecialChars">
                <app-dynamic-content
                  [contentId]="'simple-image-title'"
                  [htmlContent]="titleConfigurations.title">
                </app-dynamic-content>
              </h3>
              <kla-social-media-buttons class="mb-3" [linkFragment]="titleConfigurations.title"></kla-social-media-buttons>
            </div>
            <app-dynamic-content
              [contentId]="'simple-image-desc'"
              [htmlContent]="titleConfigurations.description">
            </app-dynamic-content>
            <ng-content select="[content]"></ng-content>
          </div>
        </div>
        <div class="col-12 col-lg-6 image-right mt-4 mt-lg-0" *ngIf="imagePosition=='right'"  [ngStyle]="{'max-width': displayWidth < 992 ? '100%' : '50%'}">
          <div class="overlay-wrap" [ngStyle]="{'max-width': imageWidth, 'max-height': imageHeight }">
            <kla-image-object [imageWidth]="imageWidth" [imageHeight]="imageHeight" [imageObject]="imageObject"></kla-image-object>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="imagePosition=='full-width'">
        <div class="col-12 mt-2 d-flex justify-content-center">
          <kla-image-object [ngClass]="imageWidth=='100%' ? 'w-100' : ''" [imageHeight]="imageHeight" [imageWidth]="imageWidth" [imageObject]="imageObject" [imageClass]="'image responsive-full-width'"></kla-image-object>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="card text-white text-center border-0" *ngIf="imagePosition == 'image-as-background'">
  <div class="blog-detail-thumb" [ngStyle]="{'background-image': 'url(' + imagePath + ')'}"></div>
  <div class="card-img-overlay black-tp-layer  pos-center py-6">
    <div class="center-holder">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-8 mx-auto">
            <h2 class="mb-4 text-white">{{titleConfigurations.title}}</h2>
            <div class="card-text d-xs-none">
              <app-dynamic-content
                [contentId]="'simple-image-desc'"
                [htmlContent]="titleConfigurations.description">
              </app-dynamic-content>
            </div>
            <ng-content select="[content]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
